export default __webpack_public_path__ + "static/media/4.b7a90029.svg";